import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'commonListItemsFilter',
})
export class CommonListItemsFilterPipe implements PipeTransform {
	transform(items: any[], searchFieldNames: string[], searchFieldValue: string): any[] {
		if (!searchFieldValue || !items || !items.length) {
			return items;
		}

		const search = searchFieldValue.toLowerCase();

		return items.filter((item) => {
			return searchFieldNames.some((field) => {
				const value = item[field];
				return typeof value === 'string' && value.toLowerCase().includes(search);
			});
		});
	}
}
